var map = {
	"./boat-1.jpg": "6861",
	"./boat-10.jpg": "2e14",
	"./boat-11.jpg": "a30a",
	"./boat-12.jpg": "79d2",
	"./boat-13.jpg": "3cd9",
	"./boat-14.jpg": "c2ea",
	"./boat-15.jpg": "c1e8",
	"./boat-16.jpg": "6841",
	"./boat-2.jpg": "f836",
	"./boat-3.jpg": "6f2d",
	"./boat-4.jpg": "4011",
	"./boat-5.jpg": "f0c6",
	"./boat-6.jpg": "2081",
	"./boat-7.jpg": "f23d",
	"./boat-8.jpg": "33ee",
	"./boat-9.jpg": "e4f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e0a";